import IdeaScreen from './IdeaScreen'
export default IdeaScreen
